module.exports = __webpack_public_path__ + "static/media/averias.9aca8541.jpg";